module.exports = __webpack_public_path__ + "assets/img/616d4d55d3152d1069b6fbfee4652bfb.png";